import http from "@/http-common";

class Users {
  getUsers(filterParams) {
    return http.get("users/", { params: filterParams });
  }

  getGroupsWithUsers(groupsIds) {
    return http.get(`users/user-in-groups/`, groupsIds);
  }
}

export default new Users();
